import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

const Breadcrumb = () => {
  const location = useLocation();
  const { hasPermissions } = useRequiredAuth();
  return (
    <>
      <div className="d-flex bread-crumb align-items-center flex-wrap">
        <>
          {/* <HorizontalRuleIcon className="rotated" /> */}
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/discipline/in-progress-cases",
              state: { statusCode: "IN_PROGRESS_CASES" },
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/discipline/in-progress-cases")
                ? "active"
                : " "
            }`}
          >
            <span className="text-truncate  menu-item">In-progress cases</span>
          </Link>
        </>
        
        <>
          <HorizontalRuleIcon className="rotated" />
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/discipline/closed-cases",
              state: { statusCode: "OTHER_CASES" },
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/discipline/closed-cases")
                ? "active"
                : " "
            }`}
          >
            <span className="text-truncate  menu-item">Closed cases</span>
          </Link>
        </>
        <>
          <HorizontalRuleIcon className="rotated" />
          <Link
            style={{ textDecoration: "none", color: "#fff" }}
            to={{
              pathname: "/discipline/dashboard",
              state: { statusCode: "DASHBOARD" },
            }}
            className={`  px-1 rounded  ${
              location.pathname.includes("/discipline/dashboard")
                ? "active"
                : " "
            }`}
          >
            <span className="text-truncate  menu-item">Dashboard</span>
          </Link>
        </>
      </div>
    </>
  );
};

export default Breadcrumb;
